/** Storage references are durable. Delivery URLs are resolved only at the edge. */
export function isPrivateBlobUrl(value: string): boolean {
  try {
    const url = new URL(value);
    return (
      url.protocol === 'https:' &&
      /^[a-z0-9]+\.private\.blob\.vercel-storage\.com$/.test(url.hostname) &&
      !url.username &&
      !url.password &&
      !url.port &&
      !url.search &&
      !url.hash
    );
  } catch {
    return false;
  }
}

/** The URL is an opaque lookup key; the route never fetches unregistered URLs. */
export function fileContentUrl<T>(value: T): T {
  if (typeof value !== 'string') return value;
  if (isPrivateBlobUrl(value))
    return `/api/files/content?url=${encodeURIComponent(value)}` as T;

  // PDF page anchors belong to the browser viewer, not the registry lookup key.
  // Other decorations remain unqualified; query parameters are never discarded.
  const pageAnchor = value.match(/#page=[1-9]\d*$/)?.[0];
  if (pageAnchor) {
    const storageUrl = value.slice(0, -pageAnchor.length);
    if (isPrivateBlobUrl(storageUrl))
      return `/api/files/content?url=${encodeURIComponent(storageUrl)}${pageAnchor}` as T;
  }
  return value;
}
